import React from 'react'
import { Edit } from '@mui/icons-material'
import { Chip, IconButton, Tooltip } from '@mui/material'

const CustomIconButton = ({ onClick, tooltipTitle, icon }) => (
  <Tooltip title={tooltipTitle}>
    <IconButton onClick={onClick}>
      {icon}
    </IconButton>
  </Tooltip>
)

export const columns = [
  {
    name: 'name',
    label: 'Cargo',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'score',
    label: 'Score',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'active',
    label: 'Status',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value) => {
        return (<Chip label={value ? "Ativo" : "Inativo"} color={value ? "success" : "error"} size='small' />)
      },
    },
  },
  {
    name: 'actions',
    label: 'Editar',
    options: {
      filter: false,
      sort: false,
      download: false,
      customBodyRender: (value) =>
        (<CustomIconButton
            onClick={value.edit}
            tooltipTitle="Editar registro"
            icon={<Edit />}
          />
        )
      ,
      setCellProps: () => ({
        style: {
          width: '100px',
        },
      }),
    },
  },
]
